import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../../proto/field-proto"
import FieldToggle_Component from "../../../components/toggle-stateless"
import {ToggleSize} from "../../../components/toggle-statefull"
import {isBulkSelection} from "../../../../../../../gd/right-click-menu"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    field           : FieldProto

    isEditable      : boolean

    onMouseEnter    : callback
    onMouseLeave    : callback
    onChange        : callback
}

export default function FieldToggle_TableCellCalculated_Hovered(props: Props) {

    const value = props.field.getViewValue(props.listItem.item)

    const toggleValue = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!props.isEditable) {
            return
        }

        props.onChange(!value)
    }

    return (
        <div className      = "cell-flex is-hovered ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent">
                <FieldToggle_Component size    = {ToggleSize.SIZE_16}
                                       value   = {value}
                                       onClick = {toggleValue}/>
            </div>
        </div>
    )
}
